import React from "react";

import { Line } from "react-chartjs-2";
const data = {
  labels: ["January", "February", "March", "April", "May", "June", "July"],

  datasets: [
    {
      label: " الرصيد الكلي",
      data: [120, 60, 250, 80, 150, 200, 4],
      borderColor: "#FF8900",
      backgroundColor: "#FCE7C3",
      yAxisID: "y",
    },
  ],
};

function ProgressChart() {
  return (
    <div className="bar-chart">
      <Line
        id="progress"
        data={data}
        options={{
          borderWidth: 1,
          fill: true,
          pointBorderColor: "#fff",
          pointBackgroundColor: "#FF8900",
          font: {
            weight: 700,
          },
          responsive: true,
          animations: {
            tension: {
              duration: 5000,
              easing: "linear",
              from: 0.4,
              to: 0,
              loop: true,
            },
          },
        }}
      />
    </div>
  );
}

export default ProgressChart;
